import { get } from '@/common/request';

const departmentMap = new Map([
  ['treeList', '/department/treeList']
]);

export default departmentMap;


interface TreeNode {
  children: TreeNode[]
desc?: string | null;
encode?: string;
gmtCreate? : string;
gmtModified?: string;
id?: number;
manager?: null;
name?: string;
parent?: TreeNode;
null
}


export function getTreeList (): Promise<TreeNode[]> {
  return get('/department/treeList', {}, { proxyApi: '/mirage', needHint: true });
}

/**
 * 部门树（包含全部和员工）
 * https://yapi.lanhanba.com/project/319/interface/api/91963
 */
export function getTreeListWithAll() {
  return get('/property/place/department/treeListWithAllAndEmployees');
}

/**
 * 部门列表
 * https://yapi.lanhanba.com/project/317/interface/api/33580
 */

export async function departmentList(params?: any) {
  return get('/department/list', { ...params }, { proxyApi: '/mirage', needHint: true });
}

export async function departmentTreeList(params?: any) {
  return get('/department/treeList', { ...params }, { proxyApi: '/mirage', needHint: true });
}

export async function getInfo(params?: any) {
  return get('/department/detail', { ...params }, { proxyApi: '/mirage', needHint: true });
}



